/* eslint-disable */
// AUTO-GENERATED by scripts/gen-config.js from .env.sipnsave.yml — DO NOT EDIT OR COMMIT.
// Typed as a loose bag (matching the prior react-native-ultimate-config default
// export); app/config.ts re-types each field into the curated `config` object.
const config: Record<string, any> = {
  "APP_NAME": "SipnSave",
  "BUNDLE_ID": "au.com.lmg.sipnsave",
  "BUNDLE_VERSION": 1,
  "MARKETING_VERSION": "3.4.20",
  "WHITE_LABEL_ID": "sipnsave",
  "APP_STORE_ID": "1447360672",
  "BASE_TENANT": "SNS",
  "BASE_URL": "https://mw.lmg-bw.au",
  "TILL_GATEWAY": "https://gateway.tillpayments.com/js/integrated/payment.1.3.min.js",
  "HOST_DOMAIN": "sipnsave.com.au",
  "DEFAULT_STORE": "C000129688",
  "DEFAULT_STORE_STATE": "SA",
  "SUMMER_CASH_GRAB_COMPETITION_NAME": "summer-cash-grab",
  "SUPPORT_EMAIL": "online@sipnsave.com.au",
  "GIFT_CARD_STORE": "sipnsavegiftstore",
  "GIFT_CARDS_PROMOTION_ID": "SipnSave-gift-card",
  "FF_IS_GIFT_CARDS_ENABLED": true,
  "FF_GIFT_CARD_ALL_STORES": false,
  "ONESIGNAL_APP_ID": "a153dc94-1efb-44ae-8c57-d0f1a99eebf5",
  "OTEL_ENABLED": true,
  "OTEL_SERVICE_NAME": "frontend-sipnsave",
  "OTEL_SAMPLE_RATE": 1,
  "OTEL_DEBUG": false,
  "USE_API_PROXY": true,
  "SENTRY_DSN": "https://b8167d415374b364ba8b8d41ef3fa710@o4504137358442496.ingest.us.sentry.io/4510655432097792",
  "APPLE_PAY_MERCHANT_NAME": "Sip'n Save",
  "APPLE_PAY_MERCHANT_ID": "merchant.com.lmg.production"
};

export default config;
